import { apikeyAtom } from "@/modules/api/apikey.store.ts";
import { clearPaypalSessionId } from "@/modules/billing/paypal/utils.ts";
import { welcomeSeenAtom } from "@/modules/dashboard/welcome.store.ts";
import { authProviderAtom } from "@/modules/login/authProvider.ts";
import { impersonationAtom } from "@/modules/user/impersonation.store.ts";
import { routerAtom } from "@/router.store.ts";
import { atomAction } from "@/utils/jotai/atomAction.ts";

export const logoutAction = atomAction(async (get, set) => {
    clearPaypalSessionId();

    set(welcomeSeenAtom, undefined);
    set(impersonationAtom, undefined);
    set(apikeyAtom, undefined);

    // Need to log out with the auth provider as well to eg. clear social logins
    // const { authProviderAtom } = await import("@/modules/login/authProvider.ts");
    const authProvider = get(authProviderAtom);
    // NB: Currently this does nothing, see comment in: auth0Provider -> auth0Logout
    await authProvider.logout({ redirectPath: "" });

    // Fallback when the auth provider does not redirect
    const router = get(routerAtom);
    // Reload the page to clear the query cache, atoms and PayPal session
    await router.navigate({ to: "/", reloadDocument: true });
});
